import { Stack } from '@mui/material';

import { SkeletonBlock } from '../../../atoms/SkeletonBlock';

import {
	MplDeutschlandTicketCardFooter,
	MplDeutschlandTicketCardSeparator,
	StyledBottomContainer,
	StyledCardContainer,
	StyledHeaderContainer,
	StyledHeaderSectionWrapper,
	StyledQRCodeWrapper,
	StyledTicketContainer,
	StyledTicketDetailsSection,
} from './components';

export const MplDeutschlandTicketCardLoading = () => {
	return (
		<StyledTicketContainer>
			<StyledCardContainer>
				<StyledHeaderContainer>
					<SkeletonBlock w={98} h={54} r={10} />
					<StyledHeaderSectionWrapper>
						<SkeletonBlock w={86} h={18} r={6} />
						<SkeletonBlock w={120} h={12} r={6} />
					</StyledHeaderSectionWrapper>
				</StyledHeaderContainer>

				<MplDeutschlandTicketCardSeparator />

				<StyledBottomContainer>
					<StyledTicketDetailsSection>
						<Stack
							direction="row"
							justifyContent="space-between"
							alignItems="center"
							gap={1}
						>
							<SkeletonBlock w="65%" h={24} r={8} />
							<SkeletonBlock w={72} h={26} r={999} />
						</Stack>
						<Stack gap={0.5}>
							<SkeletonBlock w={60} h={16} r={6} />
							<SkeletonBlock w={200} h={18} r={6} />
							<SkeletonBlock w={180} h={14} r={6} />
						</Stack>
					</StyledTicketDetailsSection>

					<StyledQRCodeWrapper>
						<SkeletonBlock w="100%" h={310} r={12} />
					</StyledQRCodeWrapper>

					<MplDeutschlandTicketCardFooter isBlurred />
				</StyledBottomContainer>
			</StyledCardContainer>
		</StyledTicketContainer>
	);
};
